module.exports = __webpack_public_path__ + "static/assets/e557f00ba60d8f757e94dcdfab9c2fbc.png";